import React, { useEffect } from 'react'
import { Container } from '@material-ui/core'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { backgroundStyle } from '../styles/background'
import { useSelector } from 'react-redux'
import { State } from '../types/state'
import { typographyStyles } from '../styles/typography'
import { Role } from '../types/user'

const LandingPage = (): JSX.Element => {
  const navigate = useNavigate()
  const { role, username } = useSelector((state: State) => state.user)
  const firstControls = useAnimation()
  const secondControls = useAnimation()
  const thirdControls = useAnimation()

  const [firstSectionRef, firstSectionInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  })
  const [secondSectionRef, secondSectionInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  })
  const [thirdSectionRef, thirdSectionInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  })

  useEffect(() => {
    if (firstSectionInView) {
      void firstControls.start({ opacity: 1, y: 0 })
    }
  }, [firstControls, firstSectionInView])

  useEffect(() => {
    if (secondSectionInView) {
      void secondControls.start({ opacity: 1, y: 0 })
    }
  }, [secondControls, secondSectionInView])

  useEffect(() => {
    if (thirdSectionInView) {
      void thirdControls.start({ opacity: 1, y: 0 })
    }
  }, [thirdControls, thirdSectionInView])

  return (
    <>
      <Container
        style={{
          textAlign: 'center',
          // marginTop: '5vh',
          // marginBottom: '5vh',
          color: '#595959'
        }}
      >
        <div style={backgroundStyle} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img src='./IB.png' style={{ width: '20vw' }} />
          <div style={{ marginLeft: '0', textAlign: 'right' }}>
            <h1 style={typographyStyles.h1}>MyPath</h1>
            <h3 style={typographyStyles.h5}>IB RASZ I SLO</h3>
          </div>
        </div>

        <motion.div
          ref={firstSectionRef}
          initial={{ opacity: 0, y: 50 }}
          animate={firstControls}
          transition={{ duration: 0.5 }}
        >
          <h6 style={{ ...typographyStyles.h1, marginTop: '0vh' }}>
            My Future | My Choice | My Path
          </h6>
          {role === Role.STUDENT && (
            <Button
              variant='contained'
              color='primary'
              style={{ marginTop: '-20vh' }}
              onClick={() => {
                navigate('/subjects-selection')
              }}
            >
              Get Started Now
            </Button>
          )}
          {!username && (
            <Button
              variant='contained'
              color='primary'
              style={{ marginTop: '-20vh' }}
              onClick={() => {
                navigate('/login')
              }}
            >
              Login
            </Button>
          )}
        </motion.div>
        {/* {username === null && (
          <>
            <Divider style={{ margin: '10vw' }} />
            <h2 style={typographyStyles.h2}>Features of Our Application</h2>
            <Grid container spacing={4} justify='center'>
              <Grid item xs={12} md={4}>
                <motion.div
                  ref={secondSectionRef}
                  initial={{ opacity: 0, y: 50 }}
                  animate={secondControls}
                  transition={{ duration: 0.5 }}
                >
                  <h5 style={typographyStyles.h5}>User-Friendly</h5>
                  <p style={typographyStyles.body1}>
                    An intuitive interface makes subject selection a breeze.
                  </p>
                </motion.div>
              </Grid>
              <Grid item xs={12} md={4}>
                <motion.div
                  ref={secondSectionRef}
                  initial={{ opacity: 0, y: 50 }}
                  animate={secondControls}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <h5 style={typographyStyles.h5}>Automatic Updates</h5>
                  <p style={typographyStyles.body1}>
                    Always use the latest IB subjects.
                  </p>
                </motion.div>
              </Grid>
              <Grid item xs={12} md={4}>
                <motion.div
                  ref={secondSectionRef}
                  initial={{ opacity: 0, y: 50 }}
                  animate={secondControls}
                  transition={{ duration: 0.5, delay: 0.4 }}
                >
                  <h5 style={typographyStyles.h5}>Data Security</h5>
                  <p style={typographyStyles.body1}>
                    Your data is secure with us, using the latest security
                    technologies.
                  </p>
                </motion.div>
              </Grid>
            </Grid>
            <Divider style={{ margin: '10vw' }} />
            <h2 style={typographyStyles.h2}>See for Yourself!</h2>
            <motion.div
              ref={thirdSectionRef}
              initial={{ opacity: 0, y: 50 }}
              animate={thirdControls}
              transition={{ duration: 0.5 }}
            >
              <p style={typographyStyles.body1}>
                Join thousands of satisfied MyPath users and start
                selecting subjects easily and pleasantly.
              </p>
              <Button
                variant='contained'
                color='primary'
                style={{ marginTop: '50px', marginBottom: '20px' }}
                onClick={() => {
                  navigate('/login')
                }}
              >
                Get Started Now
              </Button>
            </motion.div>
          </>
        )} */}
        {/* {username !== null && (
          <>
            <Divider style={{ margin: '10vw' }} />
            <h2 style={typographyStyles.h2}>
              See how many receipts you have generated
            </h2>
            <motion.div
              ref={thirdSectionRef}
              initial={{ opacity: 0, y: 50 }}
              animate={thirdControls}
              transition={{ duration: 0.5 }}
            >
              <Chart />
            </motion.div>
          </>
        )} */}
      </Container>
    </>
  )
}

export default LandingPage
